// Date range preset utilities

export const dateRangePresets = [
  { label: 'Today', value: 'today' },
  { label: 'Yesterday', value: 'yesterday' },
  { label: 'This Week', value: 'thisWeek' },
  { label: 'Last Week', value: 'lastWeek' },
  { label: 'This Month', value: 'thisMonth' },
  { label: 'Last Month', value: 'lastMonth' },
  { label: 'This Year', value: 'thisYear' },
  { label: 'Custom', value: 'custom' }
];

export const formatLocalYMD = (date) => {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const getRangeFromPreset = (preset) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  switch (preset) {
    case 'today': {
      const from = formatLocalYMD(today);
      return { from, to: from };
    }
    case 'yesterday': {
      const yest = new Date(today);
      yest.setDate(yest.getDate() - 1);
      const from = formatLocalYMD(yest);
      return { from, to: from };
    }
    case 'thisWeek': {
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - today.getDay());
      return { from: formatLocalYMD(startOfWeek), to: formatLocalYMD(today) };
    }
    case 'lastWeek': {
      const startOfLastWeek = new Date(today);
      startOfLastWeek.setDate(today.getDate() - today.getDay() - 7);
      const endOfLastWeek = new Date(startOfLastWeek);
      endOfLastWeek.setDate(startOfLastWeek.getDate() + 6);
      return { from: formatLocalYMD(startOfLastWeek), to: formatLocalYMD(endOfLastWeek) };
    }
    case 'thisMonth': {
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      return { from: formatLocalYMD(startOfMonth), to: formatLocalYMD(today) };
    }
    case 'lastMonth': {
      const startOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      return { from: formatLocalYMD(startOfLastMonth), to: formatLocalYMD(endOfLastMonth) };
    }
    case 'thisYear': {
      const startOfYear = new Date(today.getFullYear(), 0, 1);
      return { from: formatLocalYMD(startOfYear), to: formatLocalYMD(today) };
    }
    default:
      return { from: '', to: '' };
  }
};

/**
 * Given a from/to date string, return the matching preset key (if any).
 */
export const matchDatePresetToRange = (from, to) => {
  if (!from && !to) return null;
  const presets = ['today', 'yesterday', 'thisWeek', 'lastWeek', 'thisMonth', 'lastMonth', 'thisYear'];
  for (const preset of presets) {
    const range = getRangeFromPreset(preset);
    if (range.from === from && range.to === to) return preset;
  }
  return 'custom';
};

export default dateRangePresets;
